export default {
  methods: {
    nl2br (str) {
      str = str.replace(/(?:\r\n|\r|\n)/g, '<br />')
      return str.replace(/^\s*<br\s*\/?>|<br\s*\/?>\s*$/g, '')
    }
  }
}
